import {useDispatch} from 'react-redux'
import {createStore, applyMiddleware, compose} from 'redux'
import {createLogger} from 'redux-logger'
import type {ThunkDispatch} from 'redux-thunk'
import thunkMiddleware from 'redux-thunk'
import rootReducer from '@freckle/student/ts/reducers'
import {type AllActionT} from '@freckle/student/ts/reducers'
import {type StoreState} from '@freckle/student/ts/reducers/types'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const logger = createLogger()
const middleware = [thunkMiddleware, logger]

export const store = createStore(
  rootReducer,
  // @ts-expect-error - redux@4 and redux-logger have incompatible Middleware types
  composeEnhancers(applyMiddleware(...middleware))
)

export const useAppDispatch: () => ThunkDispatch<StoreState, unknown, AllActionT> = useDispatch
